import React, { useContext, useRef, useEffect } from 'react';
import { EntryContext } from '../contexts/entryContext';
import GameCard from './GameCard';

const GameOptions = () => {
    const { revealGames } = useContext(EntryContext);
    const ref = useRef(null);

    useEffect(() => {
        ref.current.focus();
    }, []);

    return (
        <div className='game-options'>
            <div ref={ref} className='game-option'>
                {revealGames?.map((revealGame, key) => (
                    <GameCard key={key} revealGame={revealGame} />
                ))}
            </div>
        </div>
    );
};

export default GameOptions;
